import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from 'utils/cn';

type SidebarCollapseButtonProps = {
  expanded: boolean;
  onToggle: () => void;
  className?: string;
};

export function SidebarCollapseButton({
  expanded,
  onToggle,
  className,
}: SidebarCollapseButtonProps) {
  const Icon = expanded ? ChevronLeft : ChevronRight;

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={expanded ? 'Collapse navigation' : 'Pin navigation open'}
      aria-expanded={expanded}
      title={expanded ? 'Collapse navigation' : 'Pin navigation open'}
      className={cn(
        'flex h-11 w-11 shrink-0 items-center justify-center rounded-lg',
        'text-content-secondary transition-colors duration-200',
        'hover:bg-surface hover:text-content',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-surface-secondary',
        className,
      )}
    >
      <Icon className="h-4 w-4" aria-hidden />
    </button>
  );
}
